import { Component, Input } from '@angular/core';
// Services
import { RulesChangeService } from '../../services/rules-change.service';
// Models
import { RULE_WORKFLOW_SECTION } from '../../models/inline-rules.model';
import { RulesEvents } from '../../models/inline-rules.event';

@Component({
	selector: 'cv-schema-render-display-rule-information',
	templateUrl: './display-rule-information.component.html'
})
export class DisplayRuleInformationComponent {
	@Input() ruleViolation: any;
	@Input() activeActions: any
	@Input() options: any;
	@Input() path: any;
	@Input() section: any;

	public ruleWorkflowSection = RULE_WORKFLOW_SECTION;
	public isFeedbackOpen = false;

	constructor(
		private rulesChange: RulesChangeService
	) {
		//
	}

	/**
	 * Doc must exist
	 * @param ruleWorkflowSection
	 * @param ruleViolation
	 */
	changeRuleFlow(ruleWorkflowSection: RULE_WORKFLOW_SECTION, ruleViolation: any = null): void {
		this.rulesChange.rulesDataChanged.next({
			type: RulesEvents.CHANGE_RULE_FLOW,
			ruleWorkflowSection,
			ruleViolation,
			path: this.path
		})
	}

	/**
	 * Toggles the visibility of the rule feedback section.
	 */
	onFeedbackToggle() {
		this.isFeedbackOpen = !this.isFeedbackOpen;
	}

	/**
	 * Closes the rule feedback section.
	 */
	closeFeedback() {
		this.isFeedbackOpen = false;
	}

	/**
	 * Determines the icon if the button that toggles the feedback section.
	 * @returns {string} - The button icon class.
	 */
	getFeedBackIcon() : string {
		return this.isFeedbackOpen ? "fa-light fa-chevron-up" : "fa-light fa-lightbulb-exclamation";
	}

	/**
	 * event to know if a violation rule has a rulesetId from DB or is a manual violation rule
	 * @returns 
	 */
	validateRuleSetId(): boolean {
		return this.ruleViolation.ruleSetId.length === 24 && /^[A-F0-9]+$/i.test(this.ruleViolation.ruleSetId.length);
	}

}
